import dayjs from 'dayjs';
import { ILanguage } from 'app/shared/model/language.model';
import { ITour } from 'app/shared/model/tour.model';

export interface ITourContent {
  id?: number | null;
  code?: string;
  title?: string | null;
  shortDescription?: string | null;
  data?: string | null;
  meta?: string | null;
  cancellation?: string | null;
  activityPath?: string | null;
  atAGlance?: string | null;
  inDetail?: string | null;
  whatIsIncluded?: string | null;
  youCanAdd?: string | null;
  importantInformation?: string | null;
  extraInfo?: string | null;
  createdDate?: dayjs.Dayjs | null;
  language?: ILanguage;
  tour?: ITour;
}

export const defaultValue: Readonly<ITourContent> = {};
